/**
 * This file bootstraps the Autodesk Assistant as a standalone bundle for
 * embedding in Drupal-rendered pages. It is loaded as a separate webpack
 * entry from the main Frontend App bundle.
 *
 * The bundle is double-gated: it renders nothing unless both
 * `isAutodeskAssistantEnabled` (host-based config) and the
 * `assistant_enabled_on_drupal` LaunchDarkly flag are truthy.
 */

// import { useFlags } from "launchdarkly-react-client-sdk";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { appTheme } from "@app/theme/weaveTheme.ts";
import { AutodeskAssistant } from "@app/components/AutodeskAssistant.tsx";
import { hasRequiredAssistantInfo } from "@app/components/app.config";
import { createLaunchDarklyProvider } from "@app/providers/LaunchDarklyProvider.tsx";
import { AuthProvider, useAuth } from "./providers/AuthProvider.tsx";

export function AssistantGate() {
  // TODO: Delete this code and replace with code below after launch.
  // This code is only temporarily here to restrict access during testing
  // to Autodesk employees with the "Autodesk Assistant Testing Group" enabled
  // in the Django admin.
  const { variation } = useAuth();
  const enabledOnDrupal = variation("assistant_enabled_on_drupal", false);

  // const flags = useFlags();
  // const enabledOnDrupal = flags.assistant_enabled_on_drupal;

  if (!hasRequiredAssistantInfo || !enabledOnDrupal) {
    return null;
  }
  return <AutodeskAssistant renderedOn="drupal" />;
}

if (!("Cypress" in window)) {
  (async function loadAssistant() {
    const LaunchDarklyProvider = await createLaunchDarklyProvider();
    const mountElement = document.createElement("div");
    document.body.appendChild(mountElement);

    createRoot(mountElement).render(
      <Router>
        <LaunchDarklyProvider>
          {/* TODO: Remove <AuthProvider /> after full Assistant rollout */}
          <AuthProvider>
            <ThemeProvider theme={appTheme}>
              <AssistantGate />
            </ThemeProvider>
          </AuthProvider>
        </LaunchDarklyProvider>
      </Router>
    );
  })();
}
